import { useQuery } from "@tanstack/react-query";
import { authApi } from "../api/auth";
import type { ClientBranding } from "../api/types";

export const DEFAULT_BRANDING: ClientBranding = {
  name: "Intelibo",
  logo_url: null,
  primary_color: "#302a7c",
  support_url: "mailto:accounts@intelibo.com",
};

/** Branding of the client named in `?client_id=` on the login page; Intelibo defaults otherwise. */
export function useBranding(clientId: string | null) {
  const query = useQuery<ClientBranding>({
    queryKey: ["branding", clientId],
    enabled: !!clientId,
    queryFn: () => authApi.clientBranding(clientId as string),
    retry: false,
  });
  return query.data ?? DEFAULT_BRANDING;
}
